import { variables as vars, tokens } from '@domain-group/fe-brary';
export default {
  base: {
    borderWidth: vars.button.borderWidth,
    borderRadius: tokens.borderRadius.inner,
    borderColour: 'transparent',
    fontWeight: vars.button.fontWeight
  },
  size: {
    mini: {
      borderRadius: tokens.borderRadius.mini,
      padding: vars.button.miniPadding,
      fontSize: vars.button.miniFontSize,
      lineHeight: vars.button.miniLineHeight
    },
    small: {
      borderRadius: tokens.borderRadius.inner,
      padding: vars.button.smallPadding,
      fontSize: vars.button.smallFontSize,
      lineHeight: vars.button.smallLineHeight
    },
    regular: {
      borderRadius: tokens.borderRadius.inner,
      padding: vars.button.padding,
      fontSize: vars.button.fontSize,
      lineHeight: vars.button.lineHeight
    },
    large: {
      borderRadius: tokens.borderRadius.inner,
      padding: vars.button.largePadding,
      fontSize: vars.button.largeFontSize,
      lineHeight: vars.button.largeLineHeight
    }
  }
};